module.exports = __webpack_public_path__ + "img/V5.cc345a9b.png";